import React from 'react';
import TablaCategorias from '../../components/tables/Categorias';

const Categorias = () => {
    return (
        <TablaCategorias/>
    );
}
 
export default Categorias;